import { createContext } from "react";

export const UserDashboardContext = createContext({});
